import React, { Component } from 'react';
import './App.css';
import Header from '../component/Header.js';//component for the header
// import Content from './Content.js'
import MainScreen from './MainScreen.js'; //component container for all other components, handles navigation
import AppChoice from './AppChoice.js'; //component that displays the buttons for asm user types to choose which app they would like to use
import LoginPage from './LoginPage.js'; //component that displays the login page

export default class App extends Component {
  constructor(props){
    super(props);
    this.state = {app:'lov',login:false,userInfo:{}};
    this.handleLogin = this.handleLogin.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.saveUserCart = this.saveUserCart.bind(this);
    this.changeRedeemable = this.changeRedeemable.bind(this);
    this.handleStateUpdate = this.handleStateUpdate.bind(this);
  }

  handleLogin(success,userInfo){ //method that passes up user info from login page
    if(success === true){
      const app = (userInfo.userType.substring(0,3) === "asm" || userInfo.name === "Heidi DeFazio" || userInfo.userType === "sys_admin")?'':"lov"; //Heidi is a special case. She is checked here and on line ~65
      this.setState({login:success,userInfo:userInfo,app:app});
    }
  }

  changeRedeemable(operation,points,lov=true){ //method that keeps track of user's redeemable points during their current session
    let userInfo = this.state.userInfo;
    if(lov){
      if(operation === "subtract"){
        userInfo.redeemable = Number(userInfo.redeemable) - Number(points);
      }else{
        userInfo.redeemable = Number(userInfo.redeemable) + Number(points);
      }
    }else{
      if(operation === "subtract"){
        userInfo.budget = Number(userInfo.budget) - Number(points);
      }else{
        userInfo.budget = Number(userInfo.budget) + Number(points);
      }
    }
    this.setState({userInfo:userInfo});
  }

  handleLogout(){ //method that triggers a page refresh which refreshes the state and logs the user out
    window.location.reload(true);
  }

  saveUserCart(cart){ //method that keeps track of the user shopping cart until logout
    this.setState({userCart:cart});
  }

  handleStateUpdate(state, newValue){ //standard method passed down to input/select components to update state
    const newState = {};
    newState[state] = newValue;
    this.setState(newState);
  }

  render() {
    const pageStyle = {
                        backgroundPosition: 'center',
                        overflow:'auto'
                      };
    let user = this.state.userInfo.userType;
    let content;
    let contentStyles;
    if(this.state.login === true){
      contentStyles = "fl w-100 bg-near-white br4 br--bottom bn";
      if((user === 'asm' || user === 'asm_regional' || user === 'asm_admin' || this.state.userInfo.name === "Heidi DeFazio" || user === 'sys_admin')&&(this.state.app === '')){ //if the user is an asm, they choose which app they wish to use. Heidi is a special case and needs access to asm budgeting.
        content = <AppChoice handleStateUpdate={this.handleStateUpdate}/>;
      }else{ //container of all containers, contains every view
        content = <MainScreen app={this.state.app} redeemable={this.changeRedeemable} userInfo={this.state.userInfo} handleStateUpdate={this.handleStateUpdate} logout={this.handleLogout} />
      }
    }else {//display login page
      contentStyles = "fl w-100 bg-white br4 br--bottom bn";
      content = <LoginPage onLogin={this.handleLogin}/>;
    }
    let title;
    if(this.state.app === 'asm'){
      title = "Promotional Orders";
    }else{
      title = "Living Our Values";      
    }
    return (
      <div className="br4 bg-near-white mainDiv">
        <div className="fl w-100 mt0 br4 bn br--top" style={{backgroundColor:'#357edd',backgroundImage:'linear-gradient(to right,#00449E,#357edd)'}}>
          <Header title={title} login={this.state.login}/>
        </div>
        <div className={contentStyles} style={pageStyle}>
          {content}
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/container/App.js